
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 47 47","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","stroke":"#515358"}}),_c('g',{attrs:{"fill":"#515358"}},[_c('path',{attrs:{"d":"M19.522 11.584a.914.914 0 00-1.293 0 5.904 5.904 0 000 8.34.915.915 0 101.293-1.296 4.072 4.072 0 010-5.751.914.914 0 000-1.293zM28.358 19.902a.914.914 0 001.292 0 5.904 5.904 0 000-8.34.914.914 0 00-1.292 1.293 4.072 4.072 0 010 5.754.914.914 0 000 1.293z"}}),_c('path',{attrs:{"d":"M16.42 22.759a.914.914 0 00.647-1.56 7.568 7.568 0 010-10.702.914.914 0 00-1.292-1.283 9.4 9.4 0 000 13.276.914.914 0 00.646.269zM30.699 9.267a.914.914 0 000 1.293 7.568 7.568 0 010 10.692.914.914 0 101.292 1.292 9.4 9.4 0 000-13.277.914.914 0 00-1.292 0z"}}),_c('path',{attrs:{"d":"M31.488 34.03a.914.914 0 00-.037-.09l-5.678-15.015a4.03 4.03 0 10-3.703 0l-5.66 14.968a.914.914 0 00-.052.135l-.942 2.48a.914.914 0 101.71.647l.914-2.417 5.883-6.541 5.892 6.571.914 2.396a.914.914 0 001.7-.655l-.941-2.478z","fill-rule":"nonzero"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/tower.svg